<mat-drawer-container class="{{ theme$ | async }}">
  <mat-drawer #releaseNotesDrawer mode="over" position="end" class="drawer-container">
    <app-release-notes></app-release-notes>
  </mat-drawer>

  <mat-drawer-content>
    <div class="d-flex custom-sidenav-container">
      <app-side-nav class="vh-100 shadow print-hide"></app-side-nav>
      <div class="content h-100 custom-sidenav-content container-fluid" [ngClass]="{ 'small-device-margin': isSmallerDevice, 'custom-sidenav-content-small': sidenavDefaultCollapsedState }">
        <app-header class="print-hide" [config]="myNavigationConfig"></app-header>
        <app-notification class="print-hide"></app-notification>
        <div class="main-wrapper p-3 module-container" [ngClass]="{ pinned: myNavigationConfig.sticky }">
          @if (loadNavigationDataService.getNavigationDataWarningStatus()) {
            <ng-container
              [ngTemplateOutlet]="noDataMessage">
            </ng-container>
          }
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>

<ng-template #noDataMessage>
  <div class="no-data-message">
    <span>{{ 'NOTIFICATION.DATA_LOADING_TOO_MUCH_TIME' | translate }}</span><br>
    <!-- <a href="mailto:support@wind.greenpowermonitor.com">support.wind@greenpowermonitor.com</a> -->
  </div>
</ng-template>